import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'

// 路由信息
import BasicLayout from '../layouts/BasicLayout'
import ChildLayout from '../layouts/ChildLayout'

import Index from '../pages/index'

import ContentLibrary from '../pages/content/library/index'
import BusinessData from '../pages/content/business/index'
import NewMedia from '../pages/content/newMedia/index'
import TradeMark from '../pages/content/tradeMark/index'

import WorksManage from '../pages/content/works-manage'
import WaitReview from '../pages/content/wait-review'

import AddContent from '../pages/content/add-content'
import AddMedia from '../pages/content/add-media'
import SameSource from '../pages/content/works-manage/same-source'
import Details from '../pages/content/details'
import DetailsNew from '../pages/content/details/indexNew'
import FormFilling from '../pages/content/form-filling'

import VideoCreate from '../pages/create/video'
import VideoEditor from '../pages/video-editor'
import AudioCreate from '../pages/create/audio'
import PictureCreate from '../pages/create/picture'
import ArticleCreate from '../pages/create/article'

import Feed from '../pages/feed'
import Category from '../pages/category'
import Tag from '../pages/tag'
import Channel from '../pages/channel'
import Crawler from '../pages/crawler'
import Question from '../pages/question'
import QuestionList from '../pages/questionList'

import Drafts from '../pages/drafts'
import Review from '../pages/review'
import AccessDenied from '../pages/403'

const routes = [
	{
		path: '/main',
		component: BasicLayout,
		routes: [
			{
				path: '/main/content',
				component: ChildLayout,
				title: '内容管理',
				icon: 'ContentManage',
				routes: [
					{
						path: '/main/content/library',
						component: ChildLayout,
						redirect: '/index',
						title: '内容库',
						routes: [{
							path: '/main/content/library/index',
							// component: ContentLibrary,
							component: lazy(() => import('../pages/content/library/index')),
							title: '内容库',
							routes: []
						},{
							path: '/main/content/library/addContent',
							// component: AddContent,
							component: lazy(() => import('../pages/content/add-content/index')),
							title: '添加内容',
							routes: []
						}]
					},
					{
						path: '/main/content/businessData',
						component: ChildLayout,
						title: '业务数据',
						redirect: '/index',
						routes: [{
							path: '/main/content/businessData/index',
							// component: BusinessData,
							component: lazy(() => import('../pages/content/business/index')),
							title: '业务数据',
							routes: []
						},]
					},
					{
						path: '/main/content/worksManage',
						component: ChildLayout,
						title: '作品管理',
						redirect: '/index',
						routes: [
							{
								path: '/main/content/worksManage/index',
								// component: WorksManage,
								component: lazy(() => import('../pages/content/works-manage')),
								title: '作品管理',
								routes: []
							},
							{
								path: '/main/content/worksManage/sameSource',
								// component: SameSource,
								component: lazy(() => import('../pages/content/works-manage/same-source')),
								title: '同源作品查看',
								routes: []
							},
						]
					},
					{
						path: '/main/content/details/:id/:tab',
						// component: Details,
						component: lazy(() => import('../pages/content/details/index')),
						routes: []
					},
					{
						path: '/main/content/detailsnew/:id/:tab',
						// component: DetailsNew,
						component: lazy(() => import('../pages/content/details/indexNew')),
						routes: []
					},
					{
						path: '/main/content/detailsmcn/:id/:key/:tab/:reviewType?',
						// component: DetailsNew,
						component: lazy(() => import('../pages/content/details/indexMcn')),
						routes: []
					},
					{
						path: '/main/content/detailsvideo/:id/:key/:tab',
						// component: DetailsNew,
						component: lazy(() => import('../pages/content/details/indexVideo')),
						routes: []
					},
				]
			},
			{
				path: '/main/review',
				component: ChildLayout,
				title: '内容审核',
				icon: 'ContentReview',
				routes: [{
					path: '/main/review/waitReview',
					// component: WaitReview,
					component: lazy(() => import('../pages/content/wait-review/index')),
					title: '增长物料审核',
					routes: []
				},{
					path: '/main/review/newMedia',
					// component: NewMedia,
					component: lazy(() => import('../pages/content/newMedia/index')),
					title: '酒旅内容审核(历史)',
					hiddenInMenu: true,
					routes: []
				},{
					path: '/main/review/newMediaMcn',
					// component: NewMedia,
					component: lazy(() => import('../pages/content/newMedia/indexMcn')),
					title: '酒旅内容审核',
					routes: []
				},
				{
					path: '/main/review/newMarket',
					component: lazy(() => import('../pages/content/newMarket/index')),
					title: '活动审核',
					routes: []
				},
				{
					path: '/main/review/newMediaVideo',
					component: lazy(() => import('../pages/content/newMedia/indexVideo')),
					title: '视频号内容审核',
					routes: []
				},{
					path: '/main/review/tradeMark',
					component: TradeMark,
					// component: lazy(() => import('../pages/content/tradeMark/index')),
					title: '品牌广告投放审核',
					routes: []
				},{
					path: '/main/review/addMedia',
					// component: AddMedia,
					component: lazy(() => import('../pages/content/add-media/index')),
					title: '上传内容',
					routes: []
				},{
					path: '/main/review/formFilling',
					// component: FormFilling,
					component: lazy(() => import('../pages/content/form-filling/index')),
					title: '表单填写',
					routes: []
				},]
			},
			{
				path: '/main/create',
				component: ChildLayout,
				title: '内容制作',
				icon: 'ContentCreate',
				routes: [
					{
						path: '/main/create/video',
						// component: VideoCreate,
						component: lazy(() => import('../pages/create/video')),
						title: '视频制作',
						routes: []
					},
					{
						path: '/main/create/audio',
						// component: AudioCreate,
						component: lazy(() => import('../pages/create/audio')),
						title: '音频制作',
						routes: []
					},
					{
						path: '/main/create/picture',
						// component: PictureCreate,
						component: lazy(() => import('../pages/create/picture')),
						title: '图片制作',
						routes: []
					},
					{
						path: '/main/create/article',
						// component: ArticleCreate,
						component: lazy(() => import('../pages/create/article')),
						title: '长图文制作',
						routes: []
					},
				]
			},
			{
				path: '/main/question',
				component: ChildLayout,
				title: '答分启',
				icon: 'Questionnaire',
				routes: [
					{
						path: '/main/question/index',
						// component: Question,
						component: lazy(() => import('../pages/question')),
						title: '创建问卷',
						routes: []
					},
					{
						path: '/main/question/list',
						// component: QuestionList,
						component: lazy(() => import('../pages/questionList')),
						title: '我的问卷',
						routes: []
					},
				]
			},
			{
				path: '/main/feed',
				// component: Feed,
				component: lazy(() => import('../pages/feed')),
				title: '信息流运营',
				icon: 'FeedManage',
				routes: []
			},
			{
				path: '/main/category',
				// component: Category,
				component: lazy(() => import('../pages/category')),
				title: '分类管理',
				icon: 'CategoryManage',
				routes: []
			},
			{
				path: '/main/tag',
				// component: Tag,
				component: lazy(() => import('../pages/tag')),
				title: '标签管理',
				icon: 'TagManage',
				routes: []
			},
			{
				path: '/main/channel',
				// component: Channel,
				component: lazy(() => import('../pages/channel')),
				title: '分发管理',
				icon: 'ChannelManage',
				routes: []
			},
			{
				path: '/main/crawler',
				// component: Crawler,
				component: lazy(() => import('../pages/crawler')),
				title: '抓取配置',
				icon: 'CrawlerSettings',
				routes: []
			},
			{
				path: '/main/materialTag',
				component: lazy(() => import('../pages/material-tag/index')),
				title: '素材打标',
				icon: 'BookOutlined',
				// alwaysShow: true,
				routes: []
			},
			{
				path: '/main/drafts',
				// component: Drafts,
				component: lazy(() => import('../pages/drafts')),
				title: '草稿箱',
				icon: 'DraftBox',
				routes: [],
				exclude: true,
			},
		]
	}, {
		path: '/',
		exact: true,
		component: () => <Redirect to="/index"></Redirect>,
		title: '首页',
	}, {
		path: '/index',
		exact: true,
		component: Index,
		title: '首页',
	},{
		path: '/login',
		exact: true,
		component: Index,
		title: '首页',
	},{
		path: '/review',
		exact: true,
		// component: Review,
		component: lazy(() => import('../pages/review')),
		title: '审核',
	},{
		path: '/videoEditor',
		// component: VideoEditor,
		component: lazy(() => import('../pages/video-editor')),
		title: '视频编辑器',
		routes: []
	}, {
		path: '/403',
		component: AccessDenied,
		title: '达芬奇平台',
		routes: []
	}
]

export default routes